import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ClubThousand } from '../../../app/package/base/cms/package/cms-domain';
import { FetchPriority } from '../../base/package/api/package/gaming/gaming-domain';
import '../ui-club-1000-card/ui-club-1000-card';
import './ui-custom-carousel';
import componentStyle from './ui-club-1000-carousel.css?inline';

const CName = 'ui-club-1000-carousel';

/**
 * @param {string} padding - This padding will be applied to the start and end of the carousel.
 */
@customElement(CName)
export class UIClub1000Carousel extends LitElement {
  static readonly styles = unsafeCSS(componentStyle);

  @property({ type: String }) fetchPriority: FetchPriority = FetchPriority.AUTO;
  @property({ type: Array }) clubThousandItems?: ClubThousand[];
  @property({ type: String }) padding = '0';
  @property({ type: Boolean }) loggedIn = false;

  render() {
    return html`<ui-custom-carousel .padding=${this.padding}>${this._renderClubThousandItemsUi(this.clubThousandItems)}</ui-custom-carousel>`;
  }

  private _renderClubThousandItemsUi(clubThousandItems: ClubThousand[] | undefined) {
    if (!clubThousandItems) {
      return nothing;
    }

    return clubThousandItems.map((clubThousand, index) => {
      return clubThousand.show_on_homepage
        ? html`
            <div class="carousel-item">
              <ui-club-1000-card
                .index=${index}
                .loggedIn=${this.loggedIn}
                .clubThousand=${clubThousand}
              ></ui-club-1000-card>
            </div>
          `
        : nothing;
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIClub1000Carousel;
  }
}
